import React from 'react';
import {
  Accordion as BaseAccordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { RichText } from '@/components';
import type { PortableTextBlock as PortableTextBlockType } from '@sanity/types';

interface Props {
  items: {
    heading: string;
    content: PortableTextBlockType;
  }[];
  heading: PortableTextBlockType;
  subheading: PortableTextBlockType;
}

function Accordion({ items, heading, subheading }: Props) {
  return (
    <section className='container'>
      <div className='container max-w-screen-lg text-center'>
        <RichText
          as='h2'
          value={heading}
        />
        <RichText
          as='p'
          value={subheading}
        />
      </div>
      <div className='border-gray m-auto mt-5 max-w-screen-lg border border-b-0 border-l-0 border-r-0'>
        <BaseAccordion
          type='single'
          collapsible
          className='w-full'
        >
          {items &&
            items.map((item, index) => {
              return (
                <AccordionItem
                  value={`item-${index.toFixed()}`}
                  key={`accordion-item-${index}`}
                >
                  <AccordionTrigger>
                    <h2>{item.heading}</h2>
                  </AccordionTrigger>
                  <AccordionContent>
                    <RichText value={item.content} />
                  </AccordionContent>
                </AccordionItem>
              );
            })}
        </BaseAccordion>
      </div>
    </section>
  );
}

export default Accordion;
